export interface RunDedupedViewOperationArgs<TPromise> {
  viewId: string | null | undefined;
  inFlightMap: Map<string, Promise<TPromise>>;
  onStart?: (viewId: string) => void;
  onFinally?: (viewId: string) => void;
  executor: () => Promise<TPromise>;
}

export function runDedupedViewOperation<TPromise>({
  viewId,
  inFlightMap,
  onStart,
  onFinally,
  executor,
}: RunDedupedViewOperationArgs<TPromise>): Promise<TPromise> | null {
  if (!viewId) {
    return null;
  }

  const existing = inFlightMap.get(viewId);
  if (existing) {
    return existing;
  }

  const promise = (async () => {
    onStart?.(viewId);
    try {
      return await executor();
    } finally {
      onFinally?.(viewId);
      inFlightMap.delete(viewId);
    }
  })();

  inFlightMap.set(viewId, promise);
  return promise;
}
